<template>
  <SelectField
    :input="value"
    :options="options"
    :label="inputLabel"
    :placeholder="inputHint"
    :inputName="inputName"
    :validatorRule="getValidatorRule(inputName)"
    :validatorTrigger="validatorTrigger"
    outlined dense
    :hideDetails="false"
    :disabled="disabled"
    @setInput="
      (value) => {
        $emit('setInput', value);
      }
    "
  />
</template>

<script lang='ts'>
import { Component, Mixins, Prop } from 'vue-property-decorator';
import SelectField from '@/components/Fields/SelectField.vue';
import ProjectFieldsMixin from '@/components/Mixins/ProjectFieldsMixin.vue';

@Component({
  components: {
    SelectField
  }
})
export default class ProjectSelectField extends Mixins(ProjectFieldsMixin) {
  @Prop({ required: true })
  public options!: any;
  @Prop()
  public disabled!: boolean;
}
</script>

<style>
</style>
